module.exports = __webpack_public_path__ + "static/media/handShake.4c601e1c.svg";